<span ngbDropdown class="insurance-status-filter" [autoClose]="true">
  <button type="button" class="btn insurance-status-filter-btn form-control dropdown-toggle search-input"
    [disabled]="disabled || isLoading" id="insuranceStatusFilterDropdown" ngbDropdownToggle>
    <div class="d-flex flex-row justify-content-between dropdown-inner">
      <span class="align-middle">{{ selectedStatusName ?? ('accidents.claims.filters.all' | transloco) }}</span>
      <i class="ph ph-caret-down lh-base"></i>
    </div>
  </button>
  <div ngbDropdownMenu aria-labelledby="insuranceStatusFilterDropdown">
    <div class="d-flex flex-column">
      <button class="btn btn-outline" (click)="onStatusSelect(null)" ngbDropdownItem>{{ 'accidents.claims.filters.all' | transloco }}</button>
      @for (status of statuses; track status.id) {
        <button class="btn btn-outline" (click)="onStatusSelect(status.id)" ngbDropdownItem>{{ status.name }}</button>
      }
    </div>
  </div>
</span>